const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaVideoTrilha: [
		{ id: 'pre_incubacao', valor: 'Pré-incubação' },
		{ id: 'pre_incubacao_ideacao', valor: 'Pré-incubação / Ideação' },
		{ id: 'pre_incubacao_prototipo', valor: 'Pré-incubação / Protótipo e Validação' },
		{ id: 'pre_incubacao_validacao', valor: 'Pré-incubação / Modelo de Negócio' },
		{ id: 'pre_incubacao_pitch', valor: 'Pré-incubação / Pitch' },
		{ id: 'incubacao', valor: 'Incubação' },
		{ id: 'incubacao_consultoria', valor: 'Incubação / Consultoria' },
		{ id: 'incubacao_meta', valor: 'Incubação / Meta' },
		{ id: 'incubacao_planejamento', valor: 'Incubação / Planejamento' },
		{ id: 'incubacao_maturidade_ano1', valor: 'Incubação / 1ª Ano' },
		{ id: 'incubacao_maturidade_ano2', valor: 'Incubação / 2ª Ano' },
		{ id: 'incubacao_maturidade_ano3', valor: 'Incubação / 3ª Ano' }
	]
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'VIDEO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'VIDEO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'VIDEO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        default:
            return state;
    }
}
